import { AuthPermission, Role, RolePermissionScope } from '@bechtel/ht-types';
import { UserDrawerValuesProps } from './list/drawer/types';

export const userDrawerDefaultValues: UserDrawerValuesProps = {
  sortBy: '',
  sortOrder: '',
  searchKeyword: null,
};

export const sortByList = [
  { id: 1, value: 'LAST_NAME', label: `Last Name` },
  { id: 2, value: 'FIRST_NAME', label: `First Name` },
];
export const checkToolRoomsRoles = (roles: Role[], rolePermissionList: RolePermissionScope[]) => {
  const permissionsList = rolePermissionList?.filter((item) => roles.findIndex((x) => x.name == item.role.name) >= 0);
  if (!permissionsList || !roles) return false;
  const isToolRoomUser = permissionsList.some(
    (item) =>
      item?.permission.name &&
      [
        AuthPermission.PICK_INVENTORY,
        AuthPermission.EDIT_TOOL_INVENTORY,
        AuthPermission.CREATE_TOOL_TRANSFER,
        AuthPermission.VIEW_USER_ADMIN,
      ].includes(item?.permission.name as AuthPermission)
  );
  return isToolRoomUser;
};
